export const FeatureTypes = {
    AlphaNumeric: 'A',
    Logic: 'L',
    Numeric: 'N',
    Range: 'R'
};